<script lang="ts">
  import FeedContainer from '../FeedContainer.svelte';
  import TopActivityIsland from '../TopActivityIsland.svelte';
  import TopDonorsIsland from '../TopDonorsIsland/TopDonorsIsland.svelte';
  import type { PostFiltersSchemaWithDynamic, SortOption } from '$src/utils/api/feed.util';
  import { onMount } from 'svelte';
  import StreamIsland from '../StreamIsland.svelte';
  import { getStream, type STREAM } from '$src/utils/api/admin/streams.util';
  import { FeedContentProvider } from '$src/utils/api/feedContentProvider.util';
  import { startedScrolling, useScrollVersionController } from '../top-island';
  import { writable, type Writable } from 'svelte/store';
  import  scrollToLastItemOnLoad  from '$lib/actions/scrollToLastItemOnLoad';
  import { me } from '$src/stores/user.store';
  import { isLoggedIn } from '$src/stores/auth.store';
  import type { PostDocument, WithCreatorData } from 'garden-common';
  import PostDetailsRenderer from '$lib/components/Modals/PostDetailsRenderer.svelte';
  import { isMobile, isTablet } from '$src/stores/media.store';

  export let sort: SortOption;
  export let filters: PostFiltersSchemaWithDynamic;
  export let useScrollVersion = false;

  let currentStream: STREAM;

  const contentProvider = new FeedContentProvider(filters, sort);

  const forYouQuery = contentProvider.forYouQuery;
  const exploreQuery = contentProvider.exploreQuery;

  const forYouPosts = contentProvider.forYouPosts;
  const explorePosts = contentProvider.explorePosts;
  let combinedPosts: (PostDocument & WithCreatorData)[];

  $: {
    if (!$isLoggedIn) {
      combinedPosts = [...($explorePosts || [])];
    } else {
      combinedPosts = [...($forYouPosts || []), ...($explorePosts || [])];
    }
  }

  $: isExhausted =
    !$forYouQuery.hasNextPage &&
    $forYouQuery.dataUpdatedAt !== 0 &&
    !$exploreQuery.hasNextPage &&
    $exploreQuery.dataUpdatedAt !== 0;

  function reset() {
    contentProvider.setSort(sort);
    contentProvider.setFilters(filters);

    contentProvider.reset();
    combinedPosts = [];

    //contentProvider.fetchForYouOrExplorePage();
  }

  $: sort, filters, reset();

  let lastPostContainer: Writable<HTMLElement> = writable();

  const combinedPostsStore = writable<typeof combinedPosts>();

  $: $combinedPostsStore = combinedPosts;

  function findCombinedPosts() {
    if (!$isLoggedIn) {
      contentProvider.fetchExplorePage();
      return;
    }

    contentProvider.fetchForYouOrExplorePage();
  }

  onMount(async () => {
    currentStream = await getStream();
  });
</script>

<PostDetailsRenderer />

<div
  class="flex flex-col-reverse p-4 md:flex-row mt-4
  {!$isMobile && !$isTablet ? 'mr-[21rem]' : ''}"
  class:pt-4={!useScrollVersion}
>
  <div
    class="w-full overflow-auto"
    use:scrollToLastItemOnLoad={{
      arrToWatch: combinedPostsStore,
      lastItemContainer: lastPostContainer,
      startedScrolling: startedScrolling
    }}
  >
    {#if !$exploreQuery.isInitialLoading && (!$me || !$forYouPosts?.length)}
      <div
        class="shadow-island mt-28 lg:mt-0 rounded-2xl w-full bg-white h-[250px] flex items-center justify-center --updated-border mb-6"
      >
        <!-- TODO: Need a design from design team -->
        <div class="text-lg text-center opacity-50">
          {#if !$me}
            Log in to see posts relevant to you
          {:else if $forYouPosts?.length == 0}
            The recent posts of people you follow will show up here
          {/if}
        </div>
      </div>
    {/if}

    <FeedContainer
      forYouItemCount={$forYouPosts?.length}
      failed={$forYouQuery.isError || $exploreQuery.isError}
      exhausted={isExhausted}
      posts={combinedPosts}
      on:reachedEnd={findCombinedPosts}
      bind:lastPostContainer={$lastPostContainer}
    />
  </div>
</div>
